import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/** Auth0 */
import { AuthGuard } from '@auth0/auth0-angular';

/** コンポーネント */
// 会員一覧（A110）
import { A110Component } from './platform/a110/a110.component';
// 入会申請(A201)
// 入会申請確認(A202)
import { A201Component } from './platform/a201/a201.component';
// 入会申請メールアドレス確認
import { A203Component } from './platform/a203/a203.component';
// 入会申請完了
import { A204Component } from './platform/a204/a204.component';
// 入会審査完了後のメールアドレス入力（ＩＤ活性化）
import { A210Component } from './platform/a210/a210.component';
// パスワード設定メール送付完了
import { A211Component } from './platform/a211/a211.component';
// 新規入会時のパスワード設定
import { A212Component } from './platform/a212/a212.component';
// 新規入会時のパスワード設定完了
import { A213Component } from './platform/a213/a213.component';
// 入会申請詳細
import { A231Component } from './platform/a231/a231.component';
// 自治体会員登録・更新画面(入力)(B101)
// 自治体会員登録・更新画面(確認画面)(B102)
import { B101Component } from './platform/b101/b101.component';
// 自治体会員登録・更新画面（登録・更新完了）(B103)
import { B103Component } from './platform/b103/b103.component';
// 会員プロフィール(自治体)
import { B211Component } from './platform/b211/b211.component';
// 会員プロフィール(民間団体)
import { B212Component } from './platform/b212/b212.component';
// ユーザー一覧(B220)
import { B220Component } from './platform/b220/b220.component';
// ユーザー一覧(B221)
import { B221Component } from './platform/b221/b221.component';
// ユーザー登録完了(B223)
import { B223Component } from './platform/b223/b223.component';
// マイページ
import { B301Component } from './platform/b301/b301.component';
// 課題・ソリューション登録(C101)
// 課題・ソリューション登録確認(C102)
import { C101Component } from './platform/c101/c101.component';
// 課題・ソリューション登録完了
import { C103Component } from './platform/c103/c103.component';
// 課題・ソリューション登録・管理
import { C104Component } from './platform/c104/c104.component';
// 課題・ソリューション一覧
import { C201Component } from './platform/c201/c201.component';
// 課題・ソリューション詳細
import { C301Component } from './platform/c301/c301.component';
// 提案登録(C401)
// 提案登録確認(C402)
import { C401Component } from './platform/c401/c401.component';
// マッチング提案登録完了
import { C403Component } from './platform/c403/c403.component';
// マッチング依頼一覧
import { C502Component } from './platform/c502/c502.component';
// 提案詳細
import { C601Component } from './platform/c601/c601.component';
// 会員入会審査一覧
import { D211Component } from './platform/secretariat-list/d211/d211.component';
// 会員更新審査
import { D212Component } from './platform/secretariat-list/d212/d212.component';
// 課題・ソリューション審査
import { D221Component } from './platform/secretariat-list/d221/d221.component';
// 提案審査
import { D231Component } from './platform/secretariat-list/d231/d231.component';
// 事務局メニュー
import { D101Component } from './platform/d101/d101.component';
// 会員主催イベント審査
import { D241Component } from './platform/secretariat-list/d241/d241.component';
// 分科会審査
import { D251Component } from './platform/secretariat-list/d251/d251.component';
// 問い合わせ一覧
import { D261Component } from './platform/secretariat-list/d261/d261.component';
// 問い合わせ詳細
import { D262Component } from './platform/d262/d262.component';
// 掲示板コメント（D271）審査
import { D271Component } from './platform/secretariat-list/d271/d271.component';
// 連携事例（D281）審査
import { D281Component } from './platform/secretariat-list/d281/d281.component';
// 掲示板通報（D281）審査
import { D291Component } from './platform/secretariat-list/d291/d291.component';
// 問い合わせ詳細
import { D292Component } from './platform/d292/d292.component';
// お知らせ一覧(E001)
// PF主催イベント一覧(E002)
// 会員主催イベント一覧(E101)
import { E001Component } from './platform/e001/e001.component';
// 会員主催イベント詳細
import { E102Component } from './platform/e102/e102.component';
// 会員主催イベント申請一覧
import { E103Component } from './platform/e103/e103.component';
// 会員主催イベント申請登録(E104)
// 会員主催イベント申請登録確認E105)
import { E104Component } from './platform/e104/e104.component';
// 会員主催イベント申請登録完了(E106)
import { E106Component } from './platform/e106/e106.component';
// 分科会一覧
import { E201Component } from './platform/e201/e201.component';
// 分科会詳細
import { E202Component } from './platform/e202/e202.component';
// 分科会申請一覧
import { E203Component } from './platform/e203/e203.component';
// 分科会申請登録(E204)
// 分科会申請登録確認(E205)
import { E204Component } from './platform/e204/e204.component';
// 分科会申請登録完了
import { E206Component } from './platform/e206/e206.component';
// 問い合わせ登録(E301)
// 問い合わせ登録確認(E302)
import { E301Component } from './platform/e301/e301.component';
// 問い合わせ登録完了
import { E303Component } from './platform/e303/e303.component';
// 分科会参加登録
import { E401Component } from './platform/e401/e401.component';
// 分科会参加登録完了
import { E403Component } from './platform/e403/e403.component';
// 会員一覧・CSVダウンロード
import { F111Component } from './platform/master/f111/f111.component';
// 課題・ソリューション一覧・CSVダウンロード
import { F121Component } from './platform/master/f121/f121.component';
// 提案一覧・CSVダウンロード
import { F131Component } from './platform/master/f131/f131.component';
// 会員主催イベント一覧・CSVダウンロード
import { F141Component } from './platform/master/f141/f141.component';
// 分科会一覧・CSVダウンロード
import { F151Component } from './platform/master/f151/f151.component';
// 分科会参加者一覧
import { F171Component } from './platform/master/f171/f171.component';
// お知らせ一覧
import { G101Component } from './platform/g101/g101.component';
// お知らせ詳細
import { G102Component } from './platform/g102/g102.component';
// お知らせ登録(E204)
// お知らせ登録確認(E205)
import { G103Component } from './platform/g103/g103.component';
// お知らせ登録完了
import { G105Component } from './platform/g105/g105.component';

// 連携事例登録(H101)
import { H101Component } from './platform/h101/h101.component';
// 連携事例登録完了(H103)
import { H103Component } from './platform/h103/h103.component';
// 連携事例管理(H104)
import { H104Component } from './platform/h104/h104.component';
// 連携事例一覧(H201)
import { H201Component } from './platform/h201/h201.component';
// 連携事例詳細(H301)
import { H301Component } from './platform/h301/h301.component';

// ダッシュボード(I101)
import { I101Component } from './platform/i101/i101.component';

// 事例紹介記事一覧(J101)
import { J101Component } from './platform/j101/j101.component';

// 事例紹介記事一覧(J201)
import { J201Component } from './platform/j201/j201.component';

// 事例紹介記事詳細(J202)
import { J202Component } from './platform/j202/j202.component';

// 事例紹介記事登録(J203)
import { J203Component } from './platform/j203/j203.component';

// 事例紹介記事登録完了(J205)
import { J205Component } from './platform/j205/j205.component';
// 掲示板スレッド一覧
import { L101Component } from './platform/l101/l101.component';
// 掲示板スレッド閲覧
import { L201Component } from './platform/l201/l201.component';
import { L301Component } from './platform/l301/l301.component';

// 入会申請修正(K101)
// 入会申請修正確認(K102)
import { K101Component } from './platform/k101/k101.component';
import { K103Component } from './platform/k103/k103.component';
import { K104Component } from './platform/k104/k104.component';

// ログアウト
import { LogoutComponent } from './logout/logout.component';
import { MainRedirectComponent } from './platform/main-redirect/main-redirect.component';

const routes: Routes = [
  {
    // マイページ(初期画面)
    path: '',
    component: B301Component,
    canActivate: [AuthGuard],
  },
  {
    // マイページ(初期画面)
    path: 'redirect',
    component: MainRedirectComponent,
    canActivate: [AuthGuard],
  },
  {
    // 会員検索（会員一覧）(A110)
    path: 'pages/platform/a110',
    component: A110Component,
  },
  {
    // 入会申請(A201)
    // 入会申請確認(A202)
    // inputType(new：新規)
    // クエリパラメータ
    // screenId (a201⇒入会申請(A201),a202⇒入会申請確認(A202))
    path: 'pages/platform/a201/:inputType',
    component: A201Component,
  },
  {
    // 入会申請修正(K101)
    // 入会申請修正確認(K102)
    // inputType(new：新規)
    // クエリパラメータ
    // screenId (k101⇒入会申請(K101),k102⇒入会申請確認(K102))
    path: 'pages/platform/k101/:application_id',
    component: K101Component,
  },
  {
    // 入会申請修正完了(K101)
    path: 'pages/platform/k103',
    component: K103Component,
  },
  {
    // 入会申請修正完了(K101)
    path: 'pages/platform/k104',
    component: K104Component,
  },
  {
    // 入会申請メールアドレス確認
    // クエリパラメータ
    // email (eメールアドレス)
    path: 'pages/platform/a203',
    component: A203Component,
  },
  {
    // 入会申請完了
    path: 'pages/platform/a204',
    component: A204Component,
  },
  {
    // 入会審査完了後のメールアドレス入力（ＩＤ活性化）
    path: 'pages/platform/a210',
    component: A210Component,
  },
  {
    // パスワード設定メール送付完了
    path: 'pages/platform/a211',
    component: A211Component,
  },
  {
    // 新規入会時のパスワード設定
    // クエリパラメータ
    // email (eメールアドレス)
    path: 'pages/platform/a212',
    component: A212Component,
  },
  {
    // 新規入会時のパスワード設定完了
    path: 'pages/platform/a213',
    component: A213Component,
  },
  {
    // 入会申請詳細
    // application_id(申請ID)
    path: 'pages/platform/a231/:application_id',
    component: A231Component,
    canActivate: [AuthGuard],
  },
  {
    // 自治体会員登録・更新画面(入力)(B101)
    // 自治体会員登録・更新画面(確認画面)(B102)
    // inputType(new：新規、edit：編集)
    // クエリパラメータ
    // screenId (b101⇒自治体会員登録・更新画面(入力)(B101),b102⇒自治体会員登録・更新画面(確認画面)(B102))
    // member_id (会員ID)
    // class_id (会員種別)
    path: 'pages/platform/b101/:inputType',
    component: B101Component,
    canActivate: [AuthGuard],
  },
  {
    // 自治体会員登録・更新画面（登録・更新完了）(B103)
    path: 'pages/platform/b103',
    component: B103Component,
    canActivate: [AuthGuard],
  },
  {
    // ユーザー一覧(B220)
    path: 'pages/platform/b220',
    component: B220Component,
    canActivate: [AuthGuard],
  },
  {
    // ユーザー登録(B221)
    // ユーザー登録確認(B222)
    // inputType(new：新規、edit：編集)
    // クエリパラメータ
    // screenId (b221⇒ユーザー登録(B221),b222⇒ユーザー登録確認(B222))
    // user (ユーザID)
    path: 'pages/platform/b221/:inputType',
    component: B221Component,
    canActivate: [AuthGuard],
  },
  {
    // ユーザー登録完了(B223)
    path: 'pages/platform/b223',
    component: B223Component,
    canActivate: [AuthGuard],
  },
  {
    // 会員プロフィール(自治体)
    // member_id (会員ID)
    path: 'pages/platform/b211/:member_id',
    component: B211Component,
  },
  {
    // 会員プロフィール(民間団体)
    // member_id (会員ID)
    path: 'pages/platform/b212/:member_id',
    component: B212Component,
  },
  {
    // マイページ
    path: 'pages/platform/b301',
    component: B301Component,
    canActivate: [AuthGuard],
  },
  {
    // 課題・ソリューション登録(C101)
    // 課題・ソリューション登録確認(C102)
    // inputType(new：新規、edit：編集)
    // クエリパラメータ
    // screenId (c101⇒課題・ソリューション登録(C101),c102⇒課題・ソリューション登録確認(C102))
    // agenda_id (課題ID)
    // agenda_kbn (区分)
    path: 'pages/platform/c101/:inputType',
    component: C101Component,
    canActivate: [AuthGuard],
  },
  {
    // 課題・ソリューション登録完了
    // クエリパラメータ
    // status (1⇒登録,0⇒一時保存)
    path: 'pages/platform/c103',
    component: C103Component,
    canActivate: [AuthGuard],
  },
  {
    // 課題・ソリューション登録・管理
    path: 'pages/platform/c104',
    component: C104Component,
  },
  {
    // 課題・ソリューション一覧
    // クエリパラメータ
    // agenda_kbn (区分)
    path: 'pages/platform/c201',
    component: C201Component,
  },
  {
    // 課題・ソリューション詳細
    // agenda_id (課題ID)
    path: 'pages/platform/c301/:agenda_id',
    component: C301Component,
  },
  {
    // 提案登録(C401)
    // 提案登録確認(C402)
    // inputType(new：新規、edit：編集)
    // クエリパラメータ
    // screenId (c401⇒提案登録(C401),c402⇒提案登録確認(C402))
    // agenda_id (課題ID)
    // suggest_id (提案ID)
    path: 'pages/platform/c401/:inputType',
    component: C401Component,
    canActivate: [AuthGuard],
  },
  {
    // マッチング提案登録完了
    path: 'pages/platform/c403',
    component: C403Component,
    canActivate: [AuthGuard],
  },
  {
    // マッチング依頼一覧
    path: 'pages/platform/c502',
    component: C502Component,
    canActivate: [AuthGuard],
  },
  {
    // 提案詳細
    // suggest_id (提案ID)
    path: 'pages/platform/c601/:suggest_id',
    component: C601Component,
    canActivate: [AuthGuard],
  },
  {
    // 事務局メニュー
    path: 'pages/platform/d101',
    component: D101Component,
  },
  {
    // 会員入会審査一覧
    path: 'pages/platform/secretariat-list/d211',
    component: D211Component,
    canActivate: [AuthGuard],
  },
  {
    // 会員更新審査
    path: 'pages/platform/secretariat-list/d212',
    component: D212Component,
    canActivate: [AuthGuard],
  },
  {
    // 課題・ソリューション審査
    path: 'pages/platform/secretariat-list/d221',
    component: D221Component,
    canActivate: [AuthGuard],
  },
  {
    // 提案審査
    path: 'pages/platform/secretariat-list/d231',
    component: D231Component,
    canActivate: [AuthGuard],
  },
  {
    // 会員主催イベント審査
    path: 'pages/platform/secretariat-list/d241',
    component: D241Component,
    canActivate: [AuthGuard],
  },
  {
    // 分科会審査
    path: 'pages/platform/secretariat-list/d251',
    component: D251Component,
    canActivate: [AuthGuard],
  },
  {
    // 問い合わせ一覧
    path: 'pages/platform/secretariat-list/d261',
    component: D261Component,
    canActivate: [AuthGuard],
  },
  {
    // 問い合わせ詳細
    // 問い合わせID(inquiry_id)
    path: 'pages/platform/d262/:inquiry_id',
    component: D262Component,
    canActivate: [AuthGuard],
  },
  {
    // 掲示板コメント（D271）審査
    path: 'pages/platform/secretariat-list/d271',
    component: D271Component,
    canActivate: [AuthGuard],
  },
  {
    // 連携事例（D281）審査
    path: 'pages/platform/secretariat-list/d281',
    component: D281Component,
    canActivate: [AuthGuard],
  },
  {
    // 掲示板通報（D291）審査
    path: 'pages/platform/secretariat-list/d291',
    component: D291Component,
    canActivate: [AuthGuard],
  },
  {
    // 掲示板通報詳細
    // 掲示板通報ID(report_id)
    path: 'pages/platform/d292/:report_id',
    component: D292Component,
    canActivate: [AuthGuard],
  },
  {
    // お知らせ一覧(E001)
    // PF主催イベント一覧(E002)
    // 会員主催イベント一覧(E101)
    // information(1：運営事務局からのお知らせ、0：会員からのお知らせ)
    path: 'pages/platform/e001/:information',
    component: E001Component,
  },
  {
    // 会員主催イベント詳細
    // member_event_id (会員主催イベントID)
    path: 'pages/platform/e102/:member_event_id',
    component: E102Component,
  },
  {
    // 会員主催イベント申請一覧
    path: 'pages/platform/e103',
    component: E103Component,
  },
  {
    // 分科会一覧
    path: 'pages/platform/e201',
    component: E201Component,
  },
  {
    // 会員主催イベント申請登録(E104)
    // 会員主催イベント申請登録確認E105)
    path: 'pages/platform/e104/:inputType',
    component: E104Component,
    canActivate: [AuthGuard],
  },
  {
    // 会員主催イベント申請登録完了(E106)
    path: 'pages/platform/e106/:inputType',
    component: E106Component,
    canActivate: [AuthGuard],
  },
  {
    // 分科会詳細
    path: 'pages/platform/e202/:subcommittee_id',
    component: E202Component,
  },
  {
    // 分科会申請一覧
    path: 'pages/platform/e203',
    component: E203Component,
    canActivate: [AuthGuard],
  },
  {
    // 分科会申請登録(E204)
    // 分科会申請登録確認(E205)
    // inputType(new：新規、edit：編集)
    // クエリパラメータ
    // screenId (e204⇒分科会申請登録(E204),e205⇒分科会申請登録確認(E205))
    // subcommittee_id (分科会ID)
    path: 'pages/platform/e204/:inputType',
    component: E204Component,
    canActivate: [AuthGuard],
  },
  {
    // 分科会申請登録完了
    path: 'pages/platform/e206',
    component: E206Component,
    canActivate: [AuthGuard],
  },
  {
    // 問い合わせ登録(E301)
    // 問い合わせ登録確認(E302)
    // inputType(new：新規)
    // クエリパラメータ
    // screenId (e301⇒問い合わせ登録(E301),e302⇒問い合わせ登録確認(E302))
    path: 'pages/platform/e301/:inputType',
    component: E301Component,
    canActivate: [AuthGuard],
  },
  {
    // 問い合わせ登録完了
    path: 'pages/platform/e303',
    component: E303Component,
    canActivate: [AuthGuard],
  },
  {
    // 分科会参加登録
    path: 'pages/platform/e401',
    component: E401Component,
    canActivate: [AuthGuard],
  },
  {
    // 分科会参加登録完了
    path: 'pages/platform/e403',
    component: E403Component,
    canActivate: [AuthGuard],
  },
  {
    // 会員一覧・CSVダウンロード
    path: 'pages/platform/master/f111',
    component: F111Component,
    canActivate: [AuthGuard],
  },
  {
    // 課題・ソリューション一覧・CSVダウンロード
    path: 'pages/platform/master/f121',
    component: F121Component,
    canActivate: [AuthGuard],
  },
  {
    // 提案一覧・CSVダウンロード
    path: 'pages/platform/master/f131',
    component: F131Component,
    canActivate: [AuthGuard],
  },
  {
    // 会員主催イベント一覧・CSVダウンロード
    path: 'pages/platform/master/f141',
    component: F141Component,
    canActivate: [AuthGuard],
  },
  {
    // 分科会一覧・CSVダウンロード
    path: 'pages/platform/master/f151',
    component: F151Component,
    canActivate: [AuthGuard],
  },
  {
    // 分科会参加者一覧
    path: 'pages/platform/master/f171',
    component: F171Component,
    canActivate: [AuthGuard],
  },
  {
    // お知らせ一覧
    path: 'pages/platform/g101',
    component: G101Component,
    canActivate: [AuthGuard],
  },
  {
    // お知らせ詳細
    path: 'pages/platform/g102/:information_id',
    component: G102Component,
    canActivate: [AuthGuard],
  },
  {
    // お知らせ登録(G103)
    // お知らせ登録確認(G104)
    // inputType(new：新規、edit：編集)
    // クエリパラメータ
    // screenId (g103⇒お知らせ登録(G103),g104⇒お知らせ登録確認(G104))
    // information_id (お知らせID)
    path: 'pages/platform/g103/:inputType',
    component: G103Component,
    canActivate: [AuthGuard],
  },
  {
    // お知らせ登録完了
    path: 'pages/platform/g105',
    component: G105Component,
    canActivate: [AuthGuard],
  },
  {
    // 連携事例登録
    path: 'pages/platform/h101/:inputType',
    component: H101Component,
    canActivate: [AuthGuard],
  },
  {
    // 連携事例登録完了
    path: 'pages/platform/h103',
    component: H103Component,
    canActivate: [AuthGuard],
  },
  {
    // 連携事例管理
    path: 'pages/platform/h104',
    component: H104Component,
    canActivate: [AuthGuard],
  },
  {
    // 連携事例一覧
    path: 'pages/platform/h201',
    component: H201Component,
  },
  {
    // 連携事例詳細
    path: 'pages/platform/h301/:cooperation_id',
    component: H301Component,
  },
  {
    // ダッシュボード
    path: 'pages/platform/i101',
    component: I101Component,
    canActivate: [AuthGuard],
  },
  {
    // 連携事例一覧
    path: 'pages/platform/j101',
    component: J101Component,
  },
  {
    // 連携事例一覧
    path: 'pages/platform/j201',
    component: J201Component,
  },
  {
    // 連携事例詳細
    path: 'pages/platform/j202/:article_id',
    component: J202Component,
  },
  {
    // 連携事例登録
    path: 'pages/platform/j203/:inputType',
    component: J203Component,
  },
  {
    // 事例紹介記事登録完了
    path: 'pages/platform/j205',
    component: J205Component,
  },
  {
    // 掲示板スレッド一覧
    path: 'pages/platform/l101',
    component: L101Component,
  },
  {
    // 掲示板スレッド詳細
    // thread_id (スレッドID)
    path: 'pages/platform/l201/:thread_id',
    component: L201Component,
  },
  {
    // 掲示板スレッド登録
    // thread_id (スレッドID)
    path: 'pages/platform/l301/:inputType',
    component: L301Component,
    canActivate: [AuthGuard]
  },
  {
    // ログアウト画面
    path: 'pages/logout',
    component: LogoutComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule { }
